var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2345_2372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.75 12.9998H16.625C17.2549 12.9998 17.859 12.8594 18.3044 12.6093C18.7498 12.3593 19 12.0201 19 11.6665V4.99984C19 4.64622 18.7498 4.30708 18.3044 4.05703C17.859 3.80698 17.2549 3.6665 16.625 3.6665H4.75C4.12011 3.6665 3.51602 3.80698 3.07062 4.05703C2.62522 4.30708 2.375 4.64622 2.375 4.99984V11.6665C2.375 12.0201 2.62522 12.3593 3.07062 12.6093C3.51602 12.8594 4.12011 12.9998 4.75 12.9998Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.56365 12V4.72727H8.15598C8.71943 4.72727 9.187 4.82434 9.55868 5.01847C9.93274 5.21259 10.2121 5.4813 10.3968 5.82457C10.5814 6.16548 10.6737 6.55966 10.6737 7.0071C10.6737 7.45218 10.5802 7.84399 10.3932 8.18253C10.2085 8.5187 9.92918 8.7803 9.55513 8.96733C9.18345 9.15436 8.71588 9.24787 8.15243 9.24787H6.18865V8.30327H8.053C8.40811 8.30327 8.69694 8.25237 8.91948 8.15057C9.14438 8.04877 9.30892 7.9008 9.41309 7.70668C9.51725 7.51255 9.56934 7.27936 9.56934 7.0071C9.56934 6.73248 9.51607 6.49455 9.40953 6.29332C9.30537 6.09209 9.14083 5.93821 8.91593 5.83168C8.69339 5.72277 8.40101 5.66832 8.0388 5.66832H6.66096V12H5.56365ZM9.15385 8.71875L10.9507 12H9.70073L7.93936 8.71875H9.15385ZM12.009 12V4.72727H16.5686V5.67188H13.1063V7.88778H16.3307V8.82884H13.1063V11.0554H16.6112V12H12.009Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2345_2372"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRe);
export default __webpack_public_path__ + "static/media/Icon RE.126091d4.svg";
export { ForwardRef as ReactComponent };